<div [ngClass]="{'smart-note-section':true, 'smart-note-section-vertical':testViewVerticalLayout, 'old':isOldVersion(), 'new':!isOldVersion()}">
  <ng-content select="[dynamicTitle]"></ng-content>
  <div *ngIf="noteTitle" class="note-title" [ngClass]="noteTitleClass">{{noteTitle}}</div>
  <div class="smart-note" *ngIf="notePopUp?.popUpIfTextIsTooLong && this.displayNote.length > 0; else noPopUp">
    <p>{{displayNote}}<span class="openPopUpBtn" (click)="openPopUp()"> Read More</span></p>
  </div>
</div>

<ng-template #noPopUp>
  <div class="smart-note"><p>{{displayNote}}</p></div>
</ng-template>



